import { createStudyEntityHookFactory } from '../createStudyEntityHookFactory';
import { StudyAssessmentMeasurement, StudyEntityType } from '@faro/study-designer-model';
import { studyAssessmentMeasurementClient } from './StudyAssessmentMeasurementClient';

const factory = createStudyEntityHookFactory<StudyAssessmentMeasurement>(StudyEntityType.StudyAssessmentMeasurement);

export const useStudyAssessmentMeasurements = factory.list(studyAssessmentMeasurementClient.list);
